import React from 'react';
import './css/Main.css';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <>
      <footer className="w-full bg-gray-900 text-gray-300 pt-12 pb-6 mt-16">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10">

          <div>
            <h3 className="text-white text-lg font-bold mb-4 border-b border-indigo-500 pb-2">AI Services</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> Agentic AI</Link></li>
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> LLM Private Model Training</Link></li>
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> RAG Implementation</Link></li>
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> Computer Vision</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-4 border-b border-indigo-500 pb-2">Technology</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> Embedded Systems</Link></li>
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> IVR Systems</Link></li>
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> Web Analytics</Link></li>
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> SMS Integration</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-4 border-b border-indigo-500 pb-2">Business</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> Digital Marketing</Link></li>
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> PR and Marketing</Link></li>
              <li><Link to="#" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> Development</Link></li>
              <li><Link to="/AU" className="hover:text-indigo-400 transition-colors flex items-center gap-2"><span className="text-indigo-500">&#x25B8;</span> About Us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white text-lg font-bold mb-4 border-b border-indigo-500 pb-2">Connect</h3>
            <div className="flex gap-4 mb-4">
              <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors text-2xl">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors text-2xl">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://twitter.com/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-sky-400 transition-colors text-2xl">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://github.com/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white transition-colors text-2xl">
                <i className="fab fa-github"></i>
              </a>
            </div>
            <p className="text-sm text-gray-500">Building intelligent systems for a smarter world.</p>
          </div>

        </div>

        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Iria Research. All Rights Reserved.</p>
        </div>
      </footer>
    </>
  );
};
